<h1 class="text-2xl font-bold">
	<slot></slot>
</h1>